import { Placeholder } from 'react-bootstrap';

const TemplateCardSkeleton = () => {
	return (
		<>
			{Array.from({ length: 5 }).map((_, index) => (
				<div key={index} className="resume-templates-field-template text-center text-sm-start">
					<Placeholder as="div" animation="glow" style={{ width: '100%', height: '100%' }}>
						<div className="resume-img-box bg-white mb-2 mb-sm-4">
							<Placeholder className="h-100 rounded-top" xs={12} />
						</div>
						<Placeholder className="rounded" as="h3" xs={12} />
						<Placeholder className="rounded" as="h4" xs={12} md={6} />
					</Placeholder>
				</div>
			))}
		</>
	);
};

export default TemplateCardSkeleton;
